import React, { forwardRef, useImperativeHandle, useState } from 'react';

import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from '@coreui/react';

const ModalConfirm = ({ onConfirm = () => {} }, ref) => {
  const [state, setState] = useState({
    visible: false,
    title: '',
    description: '',
    dataConfirm: '',
  });
  const { visible, title, description, dataConfirm } = state;

  const handleOpenConfirm = (data) => {
    setState((prev) => ({ ...prev, ...data, visible: true }));
  };

  const handleCloseConfirm = () => {
    setState((prev) => ({ ...prev, visible: false }));
  };

  useImperativeHandle(ref, () => ({
    open: handleOpenConfirm,
    close: handleCloseConfirm,
  }));

  return (
    <CModal visible={visible} onClose={handleCloseConfirm}>
      <CModalHeader>
        <CModalTitle>{title}</CModalTitle>
      </CModalHeader>
      <CModalBody style={{ fontSize: '14px' }}>{description}</CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={handleCloseConfirm}>
          Cancel
        </CButton>
        <CButton color="primary" onClick={() => onConfirm(dataConfirm)}>
          Confirm
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default forwardRef(ModalConfirm);
